import * as React from 'react';
import { connect } from 'react-redux';
import * as _ from 'underscore';

import { BodyCell, DataGrid } from '@tableau/data-grid-3-wrapper';

import { Formatters } from '../../../codegen/Localize';
import { L10n } from '../../../ts/L10n/L10n';
import { IMetricDataInfo } from '../../../ts/models/IMetricInfo';
import { selectMetricDataFromCacheForContentItem } from '../../selectors/MetricDataCacheSelector';
import { AppState } from '../../state/AppState';
import { MapStateToProps } from '../../utils/ConnectUtils';
import { StyledCellFormatter } from './StyledCellWrapper';

export function MetricUpdatedCellFormatter(): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
    function DateTimeCell(props: BodyCell.Props) {
      return <ConnectedMetricUpdatedCell {...props} />;
    }
  );
}

export interface MetricUpdatedCellStateProps {
  metricData: IMetricDataInfo;
}

export interface MetricUpdatedCellOwnProps {
  row: DataGrid.Row;
}

export type MetricUpdatedCellProps = MetricUpdatedCellOwnProps & MetricUpdatedCellStateProps;

// we have a connected metric updated cell so that as metric data comes in and updates, we only re-render the cell,
// not the whole data grid. This is tested in test\src\ts\app\spaces\ListView\DataGridCellsTests.tsx
export class MetricUpdatedCell extends React.PureComponent<MetricUpdatedCellProps> {
  public render() {
    const dateTime = this.props.metricData && this.props.metricData.dataRefreshedTimestamp;
    const updatedTime = new Date(dateTime);
    const text = dateTime ? Formatters.formatLongBestFitRelativeTime(updatedTime) : '—';

    return (
      <span data-tb-test-id="metric-updated-cell" title={dateTime ? L10n.localizedDateTime(updatedTime) : ''}>
        {text}
      </span>
      );
  }
}

const mapStateToProps: MapStateToProps<MetricUpdatedCellStateProps> = (state: AppState, ownProps: MetricUpdatedCellOwnProps) =>({
  metricData: ownProps.row.data?  selectMetricDataFromCacheForContentItem(state, ownProps.row.data) : {}
});

export const ConnectedMetricUpdatedCell = connect(mapStateToProps)(MetricUpdatedCell);
